import React, { useEffect, useState } from "react";
import axios from "../../axios";
import "./SubmitBanner.css";

/**
 * SubmitBanner
 *
 * Fetches banner visibility from the backend.
 * Shows by default (no payment rows / never dismissed).
 * When the tutor ticks the checkbox the banner is dismissed for 20 days.
 */
const SubmitBanner = () => {
  // Default to true — show the banner while the API resolves.
  // The API will explicitly hide it if the user dismissed within the last 20 days.
  const [showBanner, setShowBanner] = useState(true);
  const [loading, setLoading] = useState(true);
  const [checked, setChecked] = useState(false);
  const [dismissing, setDismissing] = useState(false);

  useEffect(() => {
    let isMounted = true;
    axios
      .get("/v1/tutor/submit-banner-status")
      .then((res) => {
        console.log(res, 'res');

        if (isMounted) {
          // Only hide if the API explicitly says not to show
          const shouldShow = res.data?.data?.showBanner;
          setShowBanner(shouldShow === false ? false : true);
        }
      })
      .catch(() => {
        // On error, keep showing the banner (fail-open)
        if (isMounted) setShowBanner(true);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  const handleCheck = async (e) => {
    if (dismissing) return;
    const isChecked = e.target.checked;
    setChecked(isChecked);
    if (!isChecked) return; // only dismiss when checking

    setDismissing(true);
    try {
      await axios.post("/v1/tutor/dismiss-submit-banner");
      // Brief delay so the user sees the checked state before it disappears
      setTimeout(() => setShowBanner(false), 600);
    } catch (err) {
      console.error("Failed to dismiss submit banner:", err);
      setChecked(false); // revert optimistic check
    } finally {
      setDismissing(false);
    }
  };

  if (!showBanner) return null;

  return (
    <div className="submit-banner" role="alert" aria-live="polite">
      <div className="submit-banner__icon" aria-hidden="true">📋</div>

      <div className="submit-banner__content">
        <p className="submit-banner__title">Complete your profile submission</p>
        <p className="submit-banner__desc">
          Make sure all your details are up to date so students can find you easily.
        </p>
      </div>

      <label className="submit-banner__checkbox-label" title="Mark as done">
        <input
          type="checkbox"
          className="submit-banner__checkbox"
          checked={checked}
          onChange={handleCheck}
          disabled={dismissing}
          aria-label="I have submitted my profile"
        />
        <span className="submit-banner__checkbox-text">Done</span>
      </label>
    </div>
  );
};

export default SubmitBanner;
